import {LOCAL_STORAGE_CHECKOUT, LOCAL_STORAGE_ORDER_DATA} from 'constants/analytics';
import {getRevenueValue} from 'libs/analytics/getOrderData';
import {prepareProductData} from 'libs/analytics/prepareProductData';
import {sendDyEventAnalytics} from 'libs/dynamicYield/dynamicYieldAnalytics';
import {isUhcEnabled} from 'libs/rollout';
import {localStore} from 'libs/storage/storage';

import {GetQuoteType} from 'mobile/actions/checkout/checkout';

import {TypPrepareProductDataType} from '../../desktop/pages/success/types/types';
import {resetOneSignalCartData, isOneSignalEnabled} from '../oneSignal/oneSignal';

/**
 * Send the Purchase event for an ordinary order
 */
export function purchaseCompleted(oid: string): Promise<void> {
    // eslint-disable-next-line max-statements, consistent-return
    return new Promise((resolve, reject) => {
        try {
            const orderData = localStore.get(LOCAL_STORAGE_ORDER_DATA);
            if (!orderData || isUhcEnabled()) return resolve();

            const checkoutJSONData = localStore.get(LOCAL_STORAGE_CHECKOUT) || '{}';
            const {quoteItems}: {quoteItems: GetQuoteType['quoteItems']} = JSON.parse(orderData);
            const {review} = JSON.parse(checkoutJSONData);
            const products = quoteItems.map((product: GetQuoteType['quoteItems'][0]) =>
                prepareProductData(product),
            );

            sendDyEventAnalytics({
                name: 'Purchase',
                properties: {
                    cart: products.map((item: TypPrepareProductDataType) => ({
                        itemPrice: Number(item.item_price),
                        productId: item.sku,
                        quantity:
                            typeof item.quantity === 'string'
                                ? parseInt(item.quantity, 10)
                                : item.quantity,
                    })),
                    currency: 'USD',
                    dyType: 'purchase-v1',
                    uniqueTransactionId: oid,
                    value: getRevenueValue(review),
                },
            });

            if (isOneSignalEnabled()) {
                resetOneSignalCartData();
            }
            resolve();
        } catch (error) {
            reject(error);
        }
    });
}
